import { Box, Container, Grid, GridItem } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import { formattedDate3 } from '../../../../helper/utils/formattedDate';
import onlineSalesAction from '../../../../redux/onlineSales/onlineSales.types';
import ProductCarts from '../../components/ProductCarts';
import ProductDetailOverview from '../../components/ProductDetail';
import useOnlineSales from '../../hooks/useOnlineSales';

export default function ProductDetailPage() {
    const dispatch = useDispatch();
    const params = useParams();
    const [searchParams, _] = useSearchParams();
    const location = useLocation();
    const state = location.state || {};

    const { handleGetProductDetails, selectedDate } = useOnlineSales();

    const id = params['id'] || '';
    const pageName = state?.pageName || '';
    const productType = state?.productType || '';
    const productId = state?.productId || '';
    const date = searchParams.get('date');

    useEffect(() => {
        if (id) {
            if (date) {
                dispatch({
                    type: onlineSalesAction.SET_STATE,
                    payload: {
                        selectedDate: new Date(date),
                        selectedDetailCurrentDate: new Date(date),
                        selectedDetailDate: new Date(date),
                    },
                });

                handleGetProductDetails(id, date, 120);
            } else {
                handleGetProductDetails(id, formattedDate3(selectedDate), 120);
            }
        }
    }, [id]);

    return (
        <Container maxW='7xl' my={7} p={0}>
            <Grid
                w='full'
                gridTemplateColumns={{
                    base: 'repeat(1, 1fr)',
                    md: 'repeat(12, 1fr)',
                }}
                gap={5}>
                <GridItem colSpan={{ base: 1, md: 8 }}>
                    <Box bg='white' rounded='xl' p={{ base: 3, md: 7 }} w='full' h='max-content'>
                        <ProductDetailOverview pageName={pageName} productType={productType} productId={productId} />
                    </Box>
                </GridItem>
                <GridItem colSpan={{ base: 1, md: 4 }}>
                    <ProductCarts />
                </GridItem>
            </Grid>
        </Container>
    );
}
